module.exports = __webpack_public_path__ + "static/media/nationwide.047bb2ae.svg";